// extracted by mini-css-extract-plugin
export var hideEditor = "_gf-2";
export var infoIcon = "_gf-3";
export var label = "_gf-1";
export var labelContainer = "_gf-0";
export var readonlyText = "_gf-4";